import React, {useEffect, Suspense} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import {useSelector} from "react-redux";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {AnimatePresence, motion} from "framer-motion";
import {ToastContainer} from "react-toastify";

import {RoutesData} from "./constants/routeConstant";
import {AuthenticatedRoute, RestrictedRoute} from "./constants/helper";
import Header from "./component/header/Header";
import Footer from "./component/footer/Footer";
import GlobalLoader from "./component/global-fields/GlobalLoader";

const theme = createTheme({
  palette: {primary: {main: "#4A4A4A"}},
  typography: {fontFamily: "Poppins, serif"},
  components: {
    MuiModal: {defaultProps: {disableScrollLock: true}},
    MuiPopover: {defaultProps: {disableScrollLock: true}},
    MuiMenu: {defaultProps: {disableScrollLock: true}},
    MuiDrawer: {defaultProps: {disableScrollLock: true}},
    MuiSelect: {defaultProps: {disableScrollLock: true}},
    MuiDialog: {defaultProps: {disableScrollLock: true}},
  },
});

const AnimatedRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"});
  }, [location]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.2}}
        exit={{opacity: 0, y: -20}}
      >
        <Suspense fallback={<GlobalLoader />}>
          <Routes location={location}>
            {RoutesData.map(
              ({path, isRestricted, isAuthenticated, element}) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    isRestricted ? (
                      <RestrictedRoute>{element}</RestrictedRoute>
                    ) : isAuthenticated ? (
                      <AuthenticatedRoute>{element}</AuthenticatedRoute>
                    ) : (
                      element
                    )
                  }
                />
              )
            )}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </motion.div>
    </AnimatePresence>
  );
};

const FooterWrapper = () => {
  const location = useLocation();
  const publicRoutes = ["/", "/contact-us", "/about-us", "/jewelers-block", "/jewelers-block-policy"];
  return publicRoutes.includes(location.pathname) ? <Footer /> : null;
};
const HeaderWrapper = () => {
  const location = useLocation();
  const noHeaderRoutes = ["/docusign/success", "/m-payment"];
  return noHeaderRoutes.includes(location.pathname) ? null : <Header />;
};

const App = () => {
  const {showLoader} = useSelector((state) => state.ui);
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar
        limit={1}
      />
      {showLoader && <GlobalLoader />}
      <Router>
        <HeaderWrapper />
        <AnimatedRoutes />
        <FooterWrapper />
      </Router>
    </ThemeProvider>
  );
};

export default App;
